import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Table,
  Label,
  FormGroup,
  Input,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";

const API_URL = "https://inspecciongnvback-dev.azurewebsites.net/api/v1";

const PresentaLista = () => {
  const { id, ordenId } = useParams();

  const [list1, setList1] = useState([]);
  const [respuestas, setRespuestas] = useState([]);
  const [cargando, setCargando] = useState(false);

  const cookie = new Cookies();

  useEffect(() => {
    let activo = true;

    const obtenerPreguntas = async () => {
      try {
        const response = await axios.get(`${API_URL}/ObtenerPregunta/${id}`, {
          auth: {
            username: "admin.icontec@icontec.org",
            password: "quAngEraMuSTerGerEDE",
          },
        });

        if (!activo) return;

        const preguntas = Array.isArray(response.data) ? response.data : [];

        setList1(preguntas);
        setRespuestas(new Array(preguntas.length).fill(""));
      } catch (error) {
        if (!activo) return;

        console.error(
          "Error al obtener las preguntas:",
          error.response?.data || error.message,
        );

        Swal.fire({
          title: "Error",
          text: "No fue posible obtener la lista de preguntas.",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      }
    };

    obtenerPreguntas();

    return () => {
      activo = false;
    };
  }, [id]);

  const handleRadioChange = (index, value) => {
    setRespuestas((prev) => {
      const nuevasRespuestas = [...prev];
      nuevasRespuestas[index] = value;
      return nuevasRespuestas;
    });
  };

  const marcarTodas = (valor) => {
    setRespuestas(new Array(list1.length).fill(valor));
  };

  const obtenerMensajeAPI = (data) => {
    if (data === null || data === undefined) {
      return "El API no devolvió un mensaje.";
    }

    if (typeof data === "string") {
      return data;
    }

    if (typeof data === "object") {
      return (
        data.mensaje ||
        data.message ||
        data.Mensaje ||
        data.Message ||
        data.descripcion ||
        data.Description ||
        JSON.stringify(data)
      );
    }

    return String(data);
  };

  const insertarRegistro = async () => {
    const total = respuestas.length;

    if (total === 0) {
      await Swal.fire({
        title: "Información",
        text: "No hay respuestas para enviar.",
        icon: "info",
        confirmButtonText: "Aceptar",
      });

      return;
    }

    if (cargando) return;

    setCargando(true);

    const nombreAuditor = cookie.get("nombre") || "";

    const payload = {
      ordenId: Number(ordenId),
      adicional: nombreAuditor,
      respuestas: list1.map((pregunta, index) => ({
        preguntaId: pregunta.id,
        respuesta: respuestas[index],
        adjunto: null,
      })),
    };

    Swal.fire({
      title: "Guardando respuestas",
      html: `
        <div style="text-align:center;">
          <strong>Procesando ${total} respuestas...</strong>
          <br/><br/>
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
        </div>
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: async () => {
        try {
          const response = await axios.post(
            `${API_URL}/CreaRespuestasBatch`,
            payload,
          );

          const mensajeAPI = obtenerMensajeAPI(response.data);

          Swal.close();

          await Swal.fire({
            title: "Proceso exitoso",
            html: `
              <div style="text-align:center;">
                <div
                  style="
                    padding:15px;
                    margin-bottom:15px;
                    background:#d4edda;
                    border-radius:5px;
                    color:#155724;
                  "
                >
                  <h4 style="margin-bottom:10px;">
                    ${mensajeAPI}
                  </h4>

                  <strong>
                    ${total} respuestas procesadas correctamente.
                  </strong>
                </div>
              </div>
            `,
            icon: "success",
            confirmButtonText: "Continuar",
            width: "600px",
          });

          window.location.href = `/admin/AdjuntosOrden/0/${ordenId}`;
        } catch (error) {
          console.error(
            "Error al enviar respuestas:",
            error.response?.data || error.message,
          );

          const mensajeError = obtenerMensajeAPI(
            error.response?.data ||
              error.message ||
              "Ocurrió un error durante el envío de las respuestas.",
          );

          Swal.close();

          await Swal.fire({
            title: "Error",
            text: mensajeError,
            icon: "error",
            confirmButtonText: "Aceptar",
          });
        } finally {
          setCargando(false);
        }
      },
    });
  };

  const guardarDatos = async () => {
    if (cargando) return;

    const hayRespuestaVacia = respuestas.some((respuesta) => !respuesta);

    if (hayRespuestaVacia) {
      await Swal.fire({
        title: "Información",
        text: "Por favor, completa todas las respuestas antes de guardar.",
        icon: "warning",
        confirmButtonText: "Aceptar",
      });

      return;
    }

    const tieneNoCumple = respuestas.includes("noCumple");

    if (tieneNoCumple) {
      await Swal.fire({
        title: "Respuestas inválidas",
        text: "No se puede continuar porque hay al menos una respuesta marcada como 'No Cumple'.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });

      return;
    }

    await insertarRegistro();
  };

  const volver = () => {
    window.location.href = "/admin/Ordenes";
  };

  const esAdministrador = cookie.get("tipoUsuarioId") == 1;

  return (
    <>
      <Header />

      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <div className="text-center">
                  <Button
                    color="warning"
                    size="lg"
                    onClick={volver}
                    disabled={cargando}
                  >
                    Volver
                  </Button>
                </div>

                <hr />

                {esAdministrador && (
                  <div className="text-center mb-3">
                    <Button
                      color="primary"
                      onClick={() => marcarTodas("cumple")}
                      disabled={cargando || list1.length === 0}
                    >
                      Marcar todo como Cumple
                    </Button>{" "}
                    <Button
                      color="danger"
                      onClick={() => marcarTodas("noCumple")}
                      disabled={cargando || list1.length === 0}
                    >
                      Marcar todo como No Cumple
                    </Button>{" "}
                    <Button
                      color="secondary"
                      onClick={() => marcarTodas("noAplica")}
                      disabled={cargando || list1.length === 0}
                    >
                      Marcar todo como No Aplica
                    </Button>
                  </div>
                )}

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col" style={{ color: "white" }}>
                        Descripción
                      </th>

                      <th scope="col" style={{ color: "white" }}>
                        Cumple
                      </th>

                      <th scope="col" style={{ color: "white" }}>
                        No Cumple
                      </th>

                      <th scope="col" style={{ color: "white" }}>
                        No Aplica
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {list1.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center">
                          <strong>No tiene lista de verificación</strong>
                        </td>
                      </tr>
                    ) : (
                      list1.map((item, index) => (
                        <tr key={item.id || index}>
                          <td
                            style={{
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                          >
                            {item.descripcion}
                          </td>

                          <td>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name={`radioGroup${index}`}
                                  value="cumple"
                                  checked={respuestas[index] === "cumple"}
                                  onChange={() =>
                                    handleRadioChange(index, "cumple")
                                  }
                                  disabled={cargando}
                                />
                              </Label>
                            </FormGroup>
                          </td>

                          <td>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name={`radioGroup${index}`}
                                  value="noCumple"
                                  checked={respuestas[index] === "noCumple"}
                                  onChange={() =>
                                    handleRadioChange(index, "noCumple")
                                  }
                                  disabled={cargando}
                                />
                              </Label>
                            </FormGroup>
                          </td>

                          <td>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="radio"
                                  name={`radioGroup${index}`}
                                  value="noAplica"
                                  checked={respuestas[index] === "noAplica"}
                                  onChange={() =>
                                    handleRadioChange(index, "noAplica")
                                  }
                                  disabled={cargando}
                                />
                              </Label>
                            </FormGroup>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </CardHeader>

              <CardBody>
                <button
                  type="button"
                  className="btn btn-primary btn-user btn-block"
                  onClick={guardarDatos}
                  disabled={cargando || list1.length === 0}
                >
                  {cargando ? "Guardando respuestas..." : "Guardar"}
                </button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PresentaLista;
